module.exports = __webpack_public_path__ + "assets/img/d070e91ac89b80a7b3307951f4cf6684.png";